import React from 'react';

import { useToggle } from 'react-use';
import { InfoBox } from '@infoods/lifebase-ui';

import { ChangePasswordRow } from './ChangePasswordRow/ChangePasswordRow';
import { CustomerChangePasswordModal } from './ChangePasswordModal/CustomerChangePasswordModal';

type CustomerPasswordBlockProps = {
  userId: number;
};

const CustomerPasswordBlock = ({ userId }: CustomerPasswordBlockProps) => {
  const [isShowChangePasswordModal, toggleShowChangePasswordModal] = useToggle(false);

  return (
    <InfoBox title="Set New Password">
      <ChangePasswordRow onPasswordChange={toggleShowChangePasswordModal} />
      {isShowChangePasswordModal && (
        <CustomerChangePasswordModal
          userId={userId}
          onClose={toggleShowChangePasswordModal}
        />
      )}
    </InfoBox>
  );
};

export { CustomerPasswordBlock };
